export default "__VITE_ASSET__By3AviR3__"